export const version = 'kunde-v1.20.0-SNAPSHOT-e7e56bd91acbabd1ead3c59764e52968ed99e433';